/**
 * @see https://github.com/GoogleChrome/web-vitals
 * @file
 */
import { type Metric, type ReportOpts } from 'web-vitals';

async function reportWebVitals(onPerfEntry?: (metric: Metric) => void, opts?: ReportOpts) {
  if (!onPerfEntry || !(onPerfEntry instanceof Function)) {
    return;
  }
  const vitals = await import('web-vitals');
  vitals.onCLS(onPerfEntry, opts);
  vitals.onFCP(onPerfEntry, opts);
  vitals.onINP(onPerfEntry, opts);
  vitals.onLCP(onPerfEntry, opts);
  vitals.onTTFB(onPerfEntry, opts);
};

export default reportWebVitals;
